<template>
    <ValidationObserver ref="observer" slim>
    <dialog class="mfa-popup-main-div country-popup-main-dev">
    <div class="titleSectionHeader">
        <span class="titleSectionHeaderTitleSpan">
            <h1 class="titleSectionHeaderTitle">{{$t( "helptopics.hklongmanloginpage.helptextheader")}}</h1>
        </span>
        <h1 id="headerTitleSR" class="sr-only"></h1>
        <a class="iconWrapper mfa-icon-btn">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="24px" height="24px">
                <path
                    d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
            </svg>
        </a>
        <hr>
    </div>
        <ul class="contentSection" id="popupListItem">
        <li tabindex="0" role="link">
            <div class="help_text_login_font"><b>{{$t( "helptopics.hklongmanloginpage.helptextCountry")}}</b></div>
            <div class="help_text_login_font">{{$t( "helptopics.hklongmanloginpage.helptextCountryD")}}</div>
        </li>
    </ul>
    </dialog>
        <b-form>
            <div v-if="typeof selfServiceDetails.error === 'string'">
                <b-alert variant="danger" show>
                    <p>{{selfServiceDetails.error}}</p>
                </b-alert>
                <div>
                    <a v-if="gotoLink" :href="gotoLink" id="sloginUrl" class="login-url" @click="backUrl">
                        {{ $t('pages.selfservice.registration.success.goToUrlText') }}
                    </a>
                </div>
            </div>
            <div v-else>
                <fr-social-buttons v-if="!isSocialReg" :signin="false"></fr-social-buttons>
                <div v-if="accountLinkingMessage" class="account-linking-message mb-3 d-flex align-items-start p-2 rounded" style="background-color: #f8f9fa; border-left: 4px solid #007bff;">
                    <i class="fa fa-info-circle text-primary mr-2 mt-1"></i>
                    <span v-html="accountLinkingMessage"></span>
                </div>
                <div class="required-fields-notice mb-3">
                    <span class="text-muted">{{ $t('pages.selfservice.registration.userDetails.requiredFieldsNotice') }}</span>
                </div>
                <b-form-group class="mb-0" v-for="(property, key) in userDetails" :key="key">
                    <fr-floating-label-input
                        :class="setClass(property)"
                        :defaultValue="property.socialValue"
                        :fieldName="key"
                        :label="property.required ? getTranslatedLabel(key) + '<span class=\'required-asterisk\'> *</span>' : getTranslatedLabel(key)"
                        :fieldNameForError="getTranslatedLabel(key)"
                        :validateRules="calculateValidation(property)"
                        :disabled="(shouldCopyEmailToUserName==true || clientFlag) && property.title === 'Username'"
                        :warningMessage="(poaClient && property.title === 'Email Address') ? emailWarningMessage : ''"
                        :showWarning="(poaClient && property.title === 'Email Address') ? showEmailWarning : false"
                        :autocompleteValue="getautocompleteValue(property)"
                        type="text"
                        v-model="saveDetails[key]"
                        @click="handleFocus"
                        @input="handleFocus"
                        @focus="handleFocus"
                        v-if="!(
                            ((revibe || pvsScholarship) && property.title === 'Username') ||
                            (clientFlag &&
                                (property.title === 'Last Name' || property.title === 'First Name')
                            ) ||
                            (pscClient && property.title === 'Username') ||
                            (mhbhpiClient && property.title === 'Username') ||
                            (mhbbdcClient && property.title === 'Username') ||
                            (poaClient && property.title === 'Username')
                        )"
                    />
                    <div class="copy-email-checkbox" v-if="pvsScholarship && property.title === 'Email Address'">{{$t('pages.selfservice.registration.userDetails.usernameforsigningin')}}</div>
                    <b-form-checkbox class="copy-email-checkbox" v-if="!clientFlag && property.title === 'Username' && !revibe && !pvsScholarship && !pscClient && !mhbhpiClient && !mhbbdcClient && !poaClient" v-model="shouldCopyEmailToUserName" @change="onCheckboxChange">
                    {{ $t('pages.selfservice.registration.copyEmail') }}
                    </b-form-checkbox>
                    <div v-if="clientFlag" style="margin-bottom: 20px;"></div>
                </b-form-group>

                <div class="mobile-number-align" v-if="showMobileField">
                    <ValidationProvider ref="mobileNumberProvider" :rules="poaClient ? 'required' : ''" v-slot="{ errors }" :name="translatedMobileNumberField">
                    <label class="ies-label mobile-text" for="phone-number">
                        {{poaClient ? $t('pages.selfservice.registration.userDetails.mobilenumberrequired') : $t('pages.selfservice.registration.userDetails.mobilenumberone')}}
                        <span v-if="poaClient" class="required-asterisk"> *</span>
                    </label>
                    <div class="mobile-number">
                        <div class="custom-dropdown">
                            <div class="dropdown-selected" id="dropdown-selected">
                                <img id="selected-flag" src="https://flagsapi.com/US/shiny/32.png"
                                    alt="" />&nbsp;&nbsp;
                                <span id="selected-dial-code"></span>
                                <img id="arrow-img" src="https://cdn-icons-png.flaticon.com/512/130/130907.png"
                                    alt="" />
                            </div>
                            <div class="dropdown-options" id="dropdown-options">
                        </div>
                    </div>
                    <input
                        id="phone-number"
                        type="text"
                        name="mobileNumber"
                        v-model="mobileNumber"
                        :class="{'ies-input': true, 'invalid': (errors.length > 0 && mobileNumber.trim() === '') || customErrorMessage !== ''}"
                        @change="handlePhoneNumber"
                        @input="formatPhoneNumberPattern($event)"
                    />
                    </div>
                    <div class="fr-validation-requirements text-left" aria-live="polite">
                        <span v-if="customErrorMessage !== ''" class="text-danger">{{ customErrorMessage }}</span>
                        <span v-else-if="errors.length > 0 && mobileNumber.trim() === ''" v-for="(error, index) in errors" :key="index" class="text-danger">{{ error }}</span>
                    </div>
                    </ValidationProvider>
                </div>

                <ValidationProvider :rules="!ukStack ? 'required' : ''" v-slot="{ errors }" :name="translatedCountryName" v-if="!clinicalEuropeClientId">
                <div class="ies-label-group" v-if="!ukStack">
                                 <div style="display: flex; align-items: center;">
                                                                        <label class="ies-label" for="country" style="width: auto; margin-bottom: 0;">
                                        {{$t('pages.selfservice.registration.userDetails.country')}}<span class="required-asterisk"> *</span>
                                    </label>
                                    <div style="display: flex; align-items: center; margin-inline-start: 6px; flex-shrink: 0;" v-if="hklongman || certprep || skillingPartner || ukStack " >
                  <b-img :src="require('@/assets/images/pearson_help.png')" :title="$t('helptopics.hklongmanloginpage.helptextMsg')" rounded="circle" width="18" height="18" alt="img" id="help_icon_login1"/>
                  </div>
                 </div>
                    <select
                        name="country"
                        id="country"
                        autocomplete="country-name"
                        v-model="handleCountryModel"
                        aria-describedby="country-ErrorMsg"
                        aria-required="true"
                        data-vv-validate-on="select|keyup|submit"
                        :class="{'ies-form-control custom-select ': true, 'invalid':  errors.length > 0}"
                        style="padding: 0.75rem 2.25rem 0.75rem 1rem"
                        :disabled="edExcelGateway"
                    >
                        <option value="" selected disabled>{{$t('pages.selfservice.registration.userDetails.selectcountry')}}</option>
                        <option v-for="(country, key) in countries" v-bind:value="country.Code" :key="key">
                            {{ country.Name }}
                        </option>
                    </select>
                    <div class="fr-validation-requirements text-left" id="country-ErrorMsg" aria-live="polite">
                        <span v-for="(error, index) in errors" :key="index" class="text-danger">{{ error }}</span>
                    </div>
                </div>
            </ValidationProvider>

            <ValidationProvider :rules="passwordValidation()" v-slot="{ errors }" :name="translatedPasswordField">
                    <div class="ies-label-group">
                                                <label class="ies-label" for="ies-password">
                                                    {{$t('pages.selfservice.registration.userDetails.password')}}<span class="required-asterisk"> *</span>
                                                </label>

                        <div class="ies-password-group">
                            <input autocomplete="new-password" aria-required="true"  id="ies-password" aria-describedby="ies-password-error" :type="inputType" :class="{'ies-input-password ': true, 'invalid': errors.length > 0}" ref="password" :reveal="true" data-vv-validate-on="blur|submit" v-model="saveDetails.userPassword" :data-vv-as="$t('pages.selfservice.registration.userDetails.password')" @keydown.space="(event) => event.preventDefault()">
                            <div class="input-group-append">
                                <button :aria-label="inputType === 'password' ? 'show password' : 'hide password'" @click="revealText" :class="{'ies-form-control ies-pw-reveal-button ': true, 'error': errors.length > 0}" type="button">
                                    <i :class="[{'fa-eye': !showeyepwd}, {'fa-eye-slash': showeyepwd}, 'fa']"></i>
                                </button>
                            </div>
                        </div>
                        <div class="fr-validation-requirements text-left" id="ies-password-error" aria-live="polite">
                            <span v-for="(error, index) in errors" :key="index" class="text-danger">{{ error }}</span>
                        </div>
                    </div>
                </ValidationProvider>
               <!-- <ValidationProvider rules="required|dob" v-slot="{ errors }" :name="translatedDOBField">
                    <div class="ies-label-group">
                        <label class="ies-label" for="ies-dob">{{$t('pages.selfservice.registration.userDetails.dob')}}</label>

                        <div class="ies-dob-group">
                            <input autocomplete="date" @input="checkConsentAge" id="ies-dob" type="text" :class="{'ies-input ': true, 'invalid': errors.length > 0}" ref="dob" data-vv-validate-on="blur|submit" v-model="saveDetails.dob" :data-vv-as="$t('pages.selfservice.registration.userDetails.dob')">
                        </div>
                        <div class="fr-validation-requirements text-left">
                            <span v-for="(error, index) in errors" :key="index" class="text-danger">{{ error }}</span>
                        </div>
                    </div>
                </ValidationProvider> -->
                <ValidationProvider rules="required" v-if='revibe' v-slot="{ errors }">
                    <div class="ies-label-group">
                       <p class="registration-consent-text">
                            <b-form-checkbox plain v-if="revibe" v-model="above18"
                                 @change="onCheckboxAbove18Change">
                                {{ $t("pages.selfservice.registration.revibe.ageConsent") }}
                            </b-form-checkbox>
                        </p>
                        <div class="fr-validation-requirements text-left" v-if='revibe'>
                            <span v-for="(error, index) in errors" :key="index" class="text-danger">
                            {{$t('pages.selfservice.registration.revibe.ageConsentError')}}</span>
                        </div>
                    </div>
                </ValidationProvider>
                <ValidationProvider rules="required" v-if="hklongman" v-slot="{ errors }">
                    <div class="ies-label-group">
                       <p class="registration-consent-text">
                            <b-form-checkbox plain v-if="hklongman" v-model="above18"
                                 @change="onCheckboxAbove18Change">
                                {{ $t("pages.selfservice.registration.hkConsent.consent1") }}
                            </b-form-checkbox>
                        </p>
                        <div class="fr-validation-requirements text-left" v-if="hklongman">
                            <span v-for="(error, index) in errors" :key="index" class="text-danger">
                            {{$t('pages.selfservice.registration.userDetails.check1')}}</span>
                        </div>
                    </div>
                </ValidationProvider>
                <ValidationProvider rules="required" v-if="hklongman" v-slot="{ errors }">
                    <div class="ies-label-group">
                        <p class="registration-consent-text">
                            <b-form-checkbox plain v-if="hklongman" v-model="act"
                                 @change="onCheckboxACTChange">
                             {{ $t("pages.selfservice.registration.hkConsent.consent2") }}
                                <a :href="personalInformationUrl" target="_blank">
                                {{$t("pages.selfservice.registration.hkConsent.personalInfAnchorText")}}
                                &nbsp;&nbsp;&nbsp;{{$t("pages.selfservice.registration.hkConsent.coolectionStmAnchorText")}}</a><span>{{$t("pages.selfservice.registration.regConsent.period")}}</span>
                            </b-form-checkbox>
                          </p>
                        <div class="fr-validation-requirements text-left" v-if="hklongman">
                            <span v-for="(error, index) in errors" :key="index" class="text-danger">
                             {{$t('pages.selfservice.registration.userDetails.check2')}}</span>
                        </div>
                    </div>
                </ValidationProvider>
                <ValidationProvider rules="required" v-if="clinicalEuropeClientId" v-slot="{ errors }">
                    <div class="ies-label-group">
                       <p class="registration-consent-text disclaimer-align">
                            <b-form-checkbox plain v-if="clinicalEuropeClientId" v-model="disclaimer"
                                 @change="onCheckboxDisclaimer">
                                {{ $t("pages.selfservice.registration.regConsent.pearsonDisclaimerAgree") }}
                                <span class="text-danger">*</span>
                            </b-form-checkbox>
                            <a class="toggle-button" @click="toggle" :block="true">
                                <i :class="isExpanded ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                            </a>
                        </p>
                        <div v-if="isExpanded" class="content">
                            <p>{{ $t("pages.selfservice.registration.regConsent.pearsonDisclaimerConsent") }}</p>
                        </div>
                        <div class="fr-validation-requirements text-left" v-if="clinicalEuropeClientId">
                            <span v-for="(error, index) in errors" :key="index" class="text-danger">
                            {{$t('pages.selfservice.registration.userDetails.disclaimer')}}</span>
                        </div>
                    </div>
                </ValidationProvider>
                        <p class="registration-consent-text" v-if="showKeepInformed">
                            <b-form-checkbox plain  v-model="keepInformed"
                                 :value="true"
                                 :unchecked-value="false">
                                 {{ $t("pages.selfservice.registration.regConsent.keepInformedConsent") }}
                            </b-form-checkbox>
                        </p>
            <!-- <fr-validation-error :validatorErrors="errors" :fieldName="key"></fr-validation-error> -->
            <b-button v-if="inline === false" @click="save" :block="true" size="lg" variant="primary">
                {{$t("common.form.signUp")}}
            </b-button>
        </div>
    </b-form>
    </ValidationObserver>
</template>

<script>
import _ from 'lodash';
import SocialButtons from '@/components/utils/SocialButtons';
import FloatingLabelInput from '@/components/utils/FloatingLabelInput';
import { CLIENT_ID, CLINICAL_EUROPE_DFLT_COUNTRY_CODE, FLAG_URL, MOBILENO_DROPDOWN } from '../../../utils/common';
import { getClientById, getRegistrationClientByUrlClientId, CLIENT } from '../../../lib/getClientById';
import InputValidations from '@/components/utils/mixins/InputValidationsMixin';
import moment from 'moment';
import $ from 'jquery';
/**
 * @description Selfservice stage for generating user details and displaying social buttons available. Works the same alone and in allinone
 *
 **/
export default {
    name: 'User-Details',
    components: {
        'fr-floating-label-input': FloatingLabelInput,
        'fr-social-buttons': SocialButtons
    },
    props: {
        selfServiceDetails: { required: true },
        inline: {
            required: false,
            default: false
        },
        showeye: String,
        showeyepwd: String
    },
    mixins: [
        InputValidations
    ],
    data () {
        // const spEntityID = this.getQueryStringValue('spEntityID');
        const clientId = this.getQueryStringValue('clientId') || getClientById();
        const Ids = ['pte_ignite_oauth_client_dev',
            'pte_ignite_oauth_client_intuat',
            'pte_ignite_oauth_client_stg',
            'pte_ignite_oauth_client',
            'pte_ignite_oauth_client_ppe'
        ];
        let data = {
            userDetails: {},
            saveDetails: {},
            disabled: false,
            inputType: 'password',
            inputConfType: 'password',
            shouldCopyEmailToUserName: clientId === CLIENT.REVIBE,
            previousUid: '',
            userPreferences: {},
            isSocialReg: _.get(this.selfServiceDetails, 'tag') !== 'initial',
            countries: [],
            phoneNumberLib: null,
            hklongman: getClientById() === CLIENT.HK_LONGMAN,
            edExcelGateway: getClientById() === CLIENT.ED_EXCEL_GATEWAY,
            certprep: getClientById() === CLIENT.CERT_PREP,
            edExcelGatewayCountry: 'GB',
            clinicalEuropeClientId: clientId?.includes('clinical-europe'),
            revibe: clientId === CLIENT.REVIBE,
            poaClient: clientId === CLIENT.POA_CLIENT,
            pvsScholarship: clientId === CLIENT.PVS_SCHOLARSHIP,
            isExpanded: false,
            ukStack: getClientById() === CLIENT.UK_STACK,
            skillingPartner: getClientById() === CLIENT.SKILLING_PARTNER,
            scholarship: getClientById() === CLIENT.SCHOLARSHIP,
            mobileNumber: '',
            dialCode: '',
            currentCountry: null,
            dropdownOptionsLoaded: false,
            dialCodeCountryList: null,
            showMobileField: ['ies-test'].includes(getClientById()) || getClientById() === CLIENT.PSC_CLIENT || clientId === CLIENT.POA_CLIENT,
            showKeepInformed: false,
            clientFlag: Ids.includes(clientId) || getClientById() === CLIENT.DAVIDE,
            pscClient: getClientById() === CLIENT.PSC_CLIENT,
            mhbhpiClient: getClientById() === CLIENT.MHBHPI_CLIENT,
            mhbbdcClient: getClientById() === CLIENT.MHBBDC_CLIENT,
            customErrorMessage: '',
            validationErrors: {
                isAccountLinking: false
            },
            emailWarningMessage: '',
            showEmailWarning: false,
            accountLinkingMessage: ''
        };
        if (this.selfServiceDetails.requirements && this.selfServiceDetails.requirements.registrationProperties) {
            data.userDetails = this.selfServiceDetails.requirements.registrationProperties.properties;

            if (_.has(this.selfServiceDetails, 'requirements.properties.user.default') &&
                    !_.isUndefined(this.selfServiceDetails, 'requirements.properties.user.default')) {
                _.each(this.selfServiceDetails.requirements.properties.user.default, (value, key) => {
                    data.userDetails[key].socialValue = value;
                });
            }

            _.each(this.selfServiceDetails.requirements.registrationProperties.required, (prop) => {
                data.userDetails[prop].required = true;
            });

            _.each(this.selfServiceDetails.requirements.registrationProperties.properties, (value, key) => {
                data.saveDetails[key] = '';
            });
            _.each(data.userDetails, (value, key) => {
                value.description = this.$t('pages.selfservice.registration.userDetails.' + key);
            });
        }

        data.saveDetails.userPassword = '';
        const registrationClientId = getRegistrationClientByUrlClientId();
        data.saveDetails.dn = 'pearsonuid=' + this.uuidv4() + ',ou=people,ou=external,dc=pearson,dc=com';
        data.saveDetails.pearsonCreatedBy = registrationClientId !== null ? registrationClientId.replace(/_/g, '') : 'OneCRM';
        data.saveDetails.pearsonUserType = 'External';
        data.saveDetails.c = '';
        data.saveDetails.pearsonAppRole = '';
        data.saveDetails.preferredLanguage = null;
        data.saveDetails.upc = false;
        // if (this.$route.query.realm === undefined) {
        //     data.saveDetails.branding = 'PEARSON';
        // } else {
        //     data.saveDetails.branding = this.$route.query.realm.replace('/', '').replace('%2f', '').replace('%2F', '').toUpperCase();
        // }
        return data;
    },
    created () {
        this.customValidations();
        if (!this.clinicalEuropeClientId && !this.ukStack) {
            this.loadCountryList();
        }
    },
    computed: {
        translatedCountryName () {
            return this.$t('pages.selfservice.registration.inputValidationMsg.country');
        },
        translatedPasswordField () {
            return this.$t('pages.selfservice.registration.inputValidationMsg.password');
        },
        translatedDOBField () {
            return this.$t('pages.selfservice.registration.userDetails.dob');
        },
        translatedMobileNumberField () {
            return this.$t('pages.selfservice.registration.userDetails.mobilenumber');
        },
        // eslint-disable-next-line vue/return-in-computed-property
        personalInformationUrl () {
            const currentLocale = this.$i18n.locale;
            const localeMap = {
                'en': 'en_GB',
                'zh': 'zh_HK'
            };
            const mappedLocale = localeMap[currentLocale] || currentLocale;
            const HKLONGMAN_PERSONALINFORMATION = {
                PERSONALINFORMATIONCOLLECTION: `https://www.pearson.com.hk/${mappedLocale}/personal-information-collection-statement.html`
            };
            if (this.hklongman) {
                return HKLONGMAN_PERSONALINFORMATION.PERSONALINFORMATIONCOLLECTION;
            }
        },
        handleCountryModel: {
            get () {
                if (this.edExcelGateway) {
                    return this.edExcelGatewayCountry;
                } else {
                    return this.saveDetails.c;
                }
            },
            set (value) {
                this.saveDetails.c = value;
            }
        },
        gotoLink () {
            const fullUrl = window.location.href;
            let goto = this.$route.query.goto;

            if (!goto) {
                const urlParams = new URLSearchParams(window.location.search);
                goto = urlParams.get('goto');
            }

            if (!goto && window.location.hash) {
                const hashParts = window.location.hash.split('?');
                if (hashParts.length > 1) {
                    const hashParams = new URLSearchParams(hashParts[1]);
                    goto = hashParams.get('goto');
                }
            }

            if (!goto) {
                const gotoMatch = fullUrl.match(/[?&]goto=([^&]*)/);
                if (gotoMatch) {
                    goto = decodeURIComponent(gotoMatch[1]);
                }
            }

            if (!goto && fullUrl.includes('goto=')) {
                try {
                    const gotoIndex = fullUrl.indexOf('goto=');
                    const afterGoto = fullUrl.substring(gotoIndex + 5);
                    let endIndex = afterGoto.indexOf('&');
                    if (endIndex === -1) {
                        endIndex = afterGoto.indexOf('#');
                    }
                    if (endIndex === -1) {
                        endIndex = afterGoto.length;
                    }
                    goto = decodeURIComponent(afterGoto.substring(0, endIndex));
                } catch (e) {
                    // ignore malformed goto
                }
            }

            return goto;
        }
    },
    watch: {
        '$i18n.locale': {
            handler () {
                if (!this.clinicalEuropeClientId && !this.ukStack) {
                    this.loadCountryList();
                }
                if (this.selfServiceDetails.requirements &&
                    this.selfServiceDetails.requirements.registrationProperties) {
                    this.userDetails = this.selfServiceDetails.requirements.registrationProperties.properties;

                    // Update descriptions with new translations
                    _.each(this.userDetails, (value, key) => {
                        value.description = this.$t('pages.selfservice.registration.userDetails.' + key);
                    });

                    // Force re-render of the entire component
                    this.$nextTick(async () => {
                        const observer = this.$refs.observer;
                        if (observer) {
                            const providers = observer.refs || {};

                            for (const [, provider] of Object.entries(providers)) {
                                if (provider && Array.isArray(provider.errors) && provider.errors.length > 0) {
                                    await provider.validate();
                                }
                            }
                        }
                        this.$forceUpdate();
                    });
                }
            },
            immediate: true
        }
    },
    mounted () {
        $('#help_icon_login').off('click').on('click', function (event) {
            $('.country-popup-main-dev').removeClass('slideIn');
            $('.country-popup-main-dev').removeAttr('open');
            $('.country-popup-main-dev').css('display', 'none');
            $('.select-popup-main-div').toggleClass('slideIn').show();
        });
        $('#help_icon_login1').off('click').on('click', function (event) {
            $('.country-popup-main-dev').toggleClass('slideIn').show();
            $('.select-popup-main-div').removeClass('slideIn');
            $('.select-popup-main-div').removeAttr('open');
            $('.select-popup-main-div').css('display', 'none');
        });
        $('.mfa-icon-btn').click(function () {
            $('.mfa-popup-main-div').removeClass('slideIn');
            $('.mfa-popup-main-div').hide();
        });
        if (this.showMobileField) {
            this.loadPhoneNumberLib();
            this.initMobileDropdown();
            this.setDefaultCountry();
            // Ensure the dial code and input properties reflect the selected default (GB for PSC, otherwise US)
            if (this.currentCountry) {
                $('#selected-dial-code').text(this.currentCountry.dialCode);
                this.dialCode = this.currentCountry.dialCode;
                this.setPhoneNumberInputProperties(this.currentCountry);
            }
        }
    },
    methods: {
        async loadCountryList () {
            const loader = this.$i18n.locale.startsWith('ar')
                ? () => import('@/assets/json/countryList-AR.json')
                : () => import('@/assets/json/countryList.json');
            this.countries = (await loader()).default;
        },
        loadPhoneNumberLib () {
            if (this.phoneNumberLib) {
                return;
            }
            import('libphonenumber-js/min').then((mod) => {
                this.phoneNumberLib = mod;
            });
        },
        getDialCodeCountryList () {
            if (!this.dialCodeCountryList) {
                this.dialCodeCountryList = MOBILENO_DROPDOWN.COUNTRY_LIST
                    .slice()
                    .sort((a, b) => a.name.localeCompare(b.name));
            }
            return this.dialCodeCountryList;
        },
        getData () {
            let details = _.clone(this.saveDetails);

            delete details.confirmPassword;

            // POA-Client: uid must equal email (username is hidden field)
            if (this.poaClient && !details.uid) {
                details.uid = details.mail;
            }

            if (this.isSocialReg) {
                delete details.userPassword;
            }
            details.cn = this.saveDetails.givenname + ' ' + this.saveDetails.sn;
            if (this.edExcelGateway) {
                details.c = this.edExcelGatewayCountry;
            }
            if (this.clinicalEuropeClientId) {
                details.c = this.getCountryCode();
            }
            // Phone number handling
            if (this.showMobileField) {
                if (this.mobileNumber && this.mobileNumber.trim() !== '') {
                    // Ensure we only include digits in the mobileNumber
                    const cleanMobileNumber = this.mobileNumber.replace(/\D/g, '');
                    details.telephoneNumber = `${this.dialCode}${cleanMobileNumber}`;
                } else if (this.poaClient) {
                    // Phone number is required for Parent Account (poaClient)
                    return null;
                }
            }
            return {
                user: details
            };
        },
        onCheckboxChange () {
            if (this.shouldCopyEmailToUserName) {
                this.previousUid = this.saveDetails.uid;
                this.saveDetails.uid = this.saveDetails.mail;
            } else {
                this.saveDetails.uid = this.previousUid !== this.saveDetails.mail ? this.previousUid : '';
            }
        },
        onCheckboxAbove18Change () {
            if (this.above18) {
                this.above18 = true;
            } else {
                this.above18 = '';
            }
        },
        onCheckboxACTChange () {
            if (this.act) {
                this.act = true;
            } else {
                this.act = '';
            }
        },
        handleFocus (e) {
            if (this.shouldCopyEmailToUserName && this.saveDetails.uid !== this.mail) {
                this.saveDetails.uid = this.saveDetails.mail;
            } else if (e.target && e.target.getAttribute('name') === 'mail' && this.saveDetails.uid === '') {
                this.shouldCopyEmailToUserName = true;
                this.saveDetails.uid = this.saveDetails.mail;
            }
        },
        revealText: function () {
            if (this.inputType === 'password') {
                this.inputType = 'text';
                this.showeyepwd = true;
            } else {
                this.inputType = 'password';
                this.showeyepwd = false;
            }
        },

        revealconfirmText: function () {
            if (this.inputConfType === 'password') {
                this.inputConfType = 'text';
                this.showeye = true;
            } else {
                this.inputConfType = 'password';
                this.showeye = false;
            }
        },

        setDropdownValue (event) {
            if (event.target.name === 'language') {
                this.saveDetails.preferredLanguage = event.target.value;
            } else if (event.target.name === 'country') {
                this.saveDetails.c = event.target.value;
                this.$emit('countrySelectedUS', event.target.value === 'US');
            } else if (event.target.name === 'role') {
                this.saveDetails.pearsonAppRole = event.target.value;
            }
        },

        // Add additional frontend checks for field validation here
        calculateValidation (property) {
            let validators = [];
            // if (property.required) {
            validators.push('required');
            // }
            //
            if (property.title === 'First Name') {
                validators.push('regFNSpaceChk');
            } else if (property.title === 'Last Name') {
                validators.push('regLNSpaceChk');
            }

            if (property.title === 'Username') {
                validators.push('regUNSpaceChk');
                validators.push('regSpecialChar');
                validators.push('isAccountLinking');
                validators.push('regUserAvailable');
                // validators.push('max:64');
            }
            if ((property.title === 'Email Address') && (this.revibe || this.pvsScholarship ||
                this.pscClient || this.mhbhpiClient || this.mhbbdcClient || this.clientFlag)) {
                validators.push('regUserAvailable');
            }
            if ((property.title === 'Email Address') && this.poaClient) {
                validators.push('poaEmailCheck');
            }

            if (property.title === 'Email Address') {
                validators.push('emailIsNotSnowflake');
            }

            if (property.policies) {
                // Add policy vee validators correlations here
                _.each(property.policies, (policy) => {
                    if (policy.policyId === 'maximum_length') {
                        validators.push('max:' + policy.params.maxLength);
                    } else if (policy.policyId === 'valid-email-address-format') {
                        validators.push('email');
                    } else if (policy.policyId === 'minimum_length') {
                        validators.push('min:' + policy.params.minLength);
                    }
                    // _.each(policy.params, (param) => {
                    // });
                });
            }
            return validators.join('|');
        },
        getTranslatedLabel (key) {
            const translatedLabel = this.$t(`pages.selfservice.registration.userDetails.${key}`);
            return translatedLabel;
        },
        getautocompleteValue (property) {
            switch (property.title) {
            case 'Email Address':
                return 'email';
            case 'Username':
                return 'username';
            case 'Last Name':
                return 'family-name';
            case 'First Name':
                return 'given-name';
            default:
                return '';
            }
        },
        checkConsentAge () {
            const parsedDate = moment(this.saveDetails.dob, 'MM-YYYY', true);
            const isValid = parsedDate.isValid() && parsedDate.endOf('month').isBefore(moment());
            if (!isValid) {
                this.$emit('toggle-keep-informed-visible', false);
                return;
            }
            const age = moment().diff(parsedDate.endOf('month'), 'years');
            const isOver18 = age >= 18;
            this.$emit('toggle-keep-informed-visible', isOver18);
        },
        displayNotification (type, message) {
            this.$store.commit('notifications/addMessage', {
                type: type,
                message: message
            });
        },

        passwordValidation () {
            this.customValidations();

            let validators = [];
            validators.push('required');

            const id = getClientById();

            switch (id) {
            case CLIENT.HK_LONGMAN:
                validators.push('minChars');
                break;
            default:
                validators.push('max:120');
                validators.push('pwdSpecialChar');
                validators.push('pwdComplexPassword');
                validators.push('pwdIsNotInBannedList');
                validators.push('pwdIsUniqueComplexPassword');
                validators.push('pwdIsNotInBannedList');
            }
            return validators.join('|');
        },

        uuidv4 () {
            return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },

        save () {
            // First check for required fields directly
            if (!this.checkRequiredFields()) {
                this.displayNotification('error', this.$t('pages.selfservice.registration.pleaseComplete'));
                return;
            }

            // For POA clients, validate mobile number specially
            if (this.poaClient && this.showMobileField) {
                // Check if mobile number exists and is not empty
                if (!this.mobileNumber || this.mobileNumber.trim() === '') {
                    this.customErrorMessage = this.$t('pages.selfservice.registration.userDetails.mobilenumberfieldrequired');
                    this.displayNotification('error', this.$t('pages.selfservice.registration.pleaseComplete'));
                    return;
                }

                // Check if mobile number format is valid
                const errorMessage = this.isInvalidMobileNumber(this.mobileNumber);
                if (errorMessage !== '') {
                    this.customErrorMessage = errorMessage;
                    this.displayNotification('error', this.$t('pages.selfservice.registration.pleaseComplete'));
                    return;
                }
            }

            // Need to ignore this validation because it does not perform in testing due to vue validate
            /* istanbul ignore next */
            this.isValid().then((valid) => {
                if (valid) {
                    // Additional check for poaClient phone number requirement
                    if (this.poaClient && this.showMobileField) {
                        // First check if it's empty
                        if (!this.mobileNumber || this.mobileNumber.trim() === '') {
                            this.customErrorMessage = this.$t('pages.selfservice.registration.userDetails.mobilenumberfieldrequired');
                            this.displayNotification('error', this.$t('pages.selfservice.registration.pleaseComplete'));
                            return;
                        }

                        // Then check format validity
                        const validationError = this.isInvalidMobileNumber(this.mobileNumber);
                        if (validationError !== '') {
                            // Phone number is invalid
                            this.customErrorMessage = validationError;
                            this.displayNotification('error', this.$t('pages.selfservice.registration.pleaseComplete'));
                            return;
                        }
                    }

                    // Get the form data for submission
                    const data = this.getData();
                    if (data === null) {
                        // Form data is invalid (this can happen if the getData method returns null)
                        this.displayNotification('error', this.$t('pages.selfservice.registration.pleaseComplete'));
                    } else {
                        // Everything is valid, proceed with form submission
                        this.$emit('advanceStage', data);
                    }
                } else {
                    this.displayNotification('error', this.$t('pages.selfservice.registration.pleaseComplete'));
                }
            }).catch(error => {
                console.error('Validation error during save:', error);
                this.displayNotification('error', this.$t('pages.selfservice.registration.pleaseComplete'));
            });
        },

        isValid () {
            /* istanbul ignore next */
            return new Promise((resolve) => {
                this.$refs.observer.validate().then((valid) => {
                    // Log all validation errors to help troubleshoot
                    const observer = this.$refs.observer;
                    if (observer) {
                        const failedFields = [];
                        for (const field in observer.fields) {
                            if (observer.fields[field].invalid) {
                                failedFields.push(field);
                            }
                        }
                    }

                    // Specific check for Mobile Number field for POA clients
                    if (this.poaClient && this.showMobileField) {
                        // First check if the field is required and empty
                        if (!this.mobileNumber || this.mobileNumber.trim() === '') {
                            this.customErrorMessage = this.$t('pages.selfservice.registration.userDetails.mobilenumberfieldrequired');
                            resolve(false);
                            return;
                        }

                        // Then check if the format is valid
                        const errorMessage = this.isInvalidMobileNumber(this.mobileNumber);
                        if (errorMessage !== '') {
                            // Phone number is invalid
                            this.customErrorMessage = errorMessage;
                            resolve(false);
                            return;
                        }

                        // If we get here and there were no other validation failures, validation passes
                        if (valid) {
                            // Clear any error message since validation passed
                            this.customErrorMessage = '';
                            resolve(true);
                            return;
                        }
                    }

                    // Handle all other validation cases
                    if (!valid) {
                        resolve(false);
                    } else {
                        this.customErrorMessage = '';
                        resolve(true);
                    }
                }).catch(error => {
                    console.error('Validation error:', error);
                    resolve(false);
                });
            });
        },
        getQueryStringValue (name) {
            let url = decodeURIComponent(window.location.href);
            name = name.replace(/[[]/, '\\["').replace(/[\]]/, '\\]');
            let regexS = '[\\?&]' + name + '=([^&#]*)';
            let regex = new RegExp(regexS);
            let results = regex.exec(url);
            return results == null ? null : results[1];
        },
        getCountryCode () {
            let countryCode = '';
            const clientId = this.getQueryStringValue('clientId') || getClientById();
            switch (clientId) {
            case CLIENT_ID.DANISH:
                countryCode = CLINICAL_EUROPE_DFLT_COUNTRY_CODE.DENMARK;
                break;
            case CLIENT_ID.DUTCH:
                countryCode = CLINICAL_EUROPE_DFLT_COUNTRY_CODE.NETHERLAND;
                break;
            case CLIENT_ID.FRENCH:
                countryCode = CLINICAL_EUROPE_DFLT_COUNTRY_CODE.FRANCE;
                break;
            case CLIENT_ID.GERMAN:
                countryCode = CLINICAL_EUROPE_DFLT_COUNTRY_CODE.GERMANY;
                break;
            case CLIENT_ID.NORWEGIAN:
                countryCode = CLINICAL_EUROPE_DFLT_COUNTRY_CODE.NORWAY;
                break;
            case CLIENT_ID.SPANISH:
                countryCode = CLINICAL_EUROPE_DFLT_COUNTRY_CODE.SPAIN;
                break;
            case CLIENT_ID.SWEDISH:
                countryCode = CLINICAL_EUROPE_DFLT_COUNTRY_CODE.SWEDEN;
                break;
            default:
                break;
            }
            return countryCode;
        },
        checkRequiredFields () {
            let hasEmptyRequiredFields = false;
            const observer = this.$refs.observer;

            if (observer) {
                // Check all fields in the validation observer
                for (const field in observer.fields) {
                    if (observer.fields[field].required) {
                        // Get the field name (in camelCase or as it appears in saveDetails)
                        const fieldName = observer.fields[field].name;
                        const fieldKey = fieldName in this.saveDetails
                            ? fieldName
                            : Object.keys(this.saveDetails).find(key =>
                                key.toLowerCase() === fieldName.toLowerCase());

                        if (fieldKey && (!this.saveDetails[fieldKey] || this.saveDetails[fieldKey].trim() === '')) {
                            hasEmptyRequiredFields = true;
                        }
                    }
                }

                // Special handling for POA client phone number
                if (this.poaClient && this.showMobileField) {
                    if (!this.mobileNumber || this.mobileNumber.trim() === '') {
                        this.customErrorMessage = this.$t('pages.selfservice.registration.userDetails.mobilenumberfieldrequired');
                        hasEmptyRequiredFields = true;
                    } else {
                        // Check if the phone number format is valid
                        const errorMessage = this.isInvalidMobileNumber(this.mobileNumber);
                        if (errorMessage !== '') {
                            this.customErrorMessage = errorMessage;
                            hasEmptyRequiredFields = true;
                        }
                    }
                }
            }

            return !hasEmptyRequiredFields;
        },
        onCheckboxDisclaimer () {
            if (this.disclaimer) {
                this.disclaimer = true;
            } else {
                this.disclaimer = '';
            }
        },
        toggle () {
            this.isExpanded = !this.isExpanded;
        },
        formatPhoneNumberPattern (e) {
            // Only allow digits in the phone number input
            const oldValue = e.target.value;
            const digitsOnly = oldValue.replace(/\D/g, '');

            // Update the input value with digits only
            e.target.value = digitsOnly;
            this.mobileNumber = digitsOnly;
            // Force Vue validation to run
            this.$nextTick(() => {
                // Check if there's a specific mobile number provider
                if (this.$refs.mobileNumberProvider) {
                    this.$refs.mobileNumberProvider.validate();
                } else {
                    // Fall back to the full observer
                    this.$refs.observer.validate();
                }
            });

            // Empty field check for poaClient (where it's required)
            if (digitsOnly.trim() === '' && this.poaClient) {
                this.customErrorMessage = this.$t('pages.selfservice.registration.userDetails.mobilenumberfieldrequired');
                return;
            }

            // If empty but not required, just clear any errors
            if (digitsOnly.trim() === '' && !this.poaClient) {
                this.customErrorMessage = '';
                return;
            }

            // If not empty, check for validation errors
            if (digitsOnly.trim() !== '') {
                const errorMessage = this.isInvalidMobileNumber(digitsOnly);
                if (errorMessage === '') {
                    // Valid phone number - clear errors
                    this.customErrorMessage = '';
                } else {
                    // Invalid phone number - show errors
                    this.customErrorMessage = errorMessage;
                }
            }
        },

        handlePhoneNumber (e) {
            // Get the cleaned value (digits only)
            const updatedMobileNumber = e.target.value.replace(/\D/g, '');
            this.mobileNumber = updatedMobileNumber;

            // Force validation refresh
            this.$nextTick(() => {
                // Check if there's a specific mobile number provider
                if (this.$refs.mobileNumberProvider) {
                    this.$refs.mobileNumberProvider.validate();
                } else {
                    // Fall back to the full observer
                    this.$refs.observer.validate();
                }
            });

            // Empty field handling
            if (updatedMobileNumber.trim() === '') {
                if (this.poaClient) {
                    // For poaClient, phone number is required
                    this.customErrorMessage = this.$t('pages.selfservice.registration.userDetails.mobilenumberfieldrequired');
                } else {
                    this.customErrorMessage = '';
                }
                return;
            }

            // Check for validation errors
            const errorMessage = this.isInvalidMobileNumber(updatedMobileNumber);
            if (errorMessage === '') {
                // Valid phone number - clear errors
                this.customErrorMessage = '';
            } else {
                // Invalid phone number - show errors
                this.customErrorMessage = errorMessage;
            }
        },
        initMobileDropdown () {
            const selectedElement = document.getElementById('dropdown-selected');
            const optionsContainer = document.getElementById('dropdown-options');
            if (!selectedElement || !optionsContainer) {
                return;
            }
            selectedElement.addEventListener('click', (event) => {
                event.stopPropagation();
                if (!this.dropdownOptionsLoaded) {
                    this.loadDropdownOptions();
                    this.dropdownOptionsLoaded = true;
                }
                optionsContainer.style.display = optionsContainer.style.display === 'block' ? 'none' : 'block';
            });
            document.addEventListener('click', (event) => {
                if (!selectedElement.contains(event.target) && !optionsContainer.contains(event.target)) {
                    optionsContainer.style.display = 'none';
                }
            });
            document.addEventListener('keyup', (event) => {
                const isOpen = optionsContainer.style.display === 'block';
                if (isOpen) {
                    for (const item of optionsContainer.children) {
                        if (item.dataset.countryname.toLowerCase().startsWith(event.key.toLowerCase())) {
                            item.scrollIntoView({ behavior: 'smooth' });
                            break;
                        }
                    }
                }
            });
        },
        loadDropdownOptions () {
            const optionsContainer = document.getElementById('dropdown-options');
            if (!optionsContainer) {
                return;
            }
            this.getDialCodeCountryList().forEach((country) => {
                const flagUrl = `${FLAG_URL}${country.code}.svg`;
                const optionDiv = document.createElement('div');
                optionDiv.setAttribute('data-country', JSON.stringify(country));
                optionDiv.setAttribute('data-countryname', country.name);
                const flagImage = document.createElement('img');
                flagImage.src = flagUrl;
                flagImage.alt = `${country.name} flag`;
                const countryName = document.createElement('span');
                countryName.textContent = country.name;
                optionDiv.appendChild(flagImage);
                optionDiv.appendChild(countryName);
                optionDiv.addEventListener('click', () => {
                    this.selectCountry(country);
                });
                optionsContainer.appendChild(optionDiv);
            });
        },
        selectCountry (country) {
            this.currentCountry = country;
            const selectedFlag = document.getElementById('selected-flag');
            selectedFlag && (selectedFlag.src = `${FLAG_URL}${country.code}.svg`);
            $('#selected-dial-code').text(country.dialCode);
            this.dialCode = country.dialCode;
            const dropdownOptions = document.getElementById('dropdown-options');
            dropdownOptions && (dropdownOptions.style.display = 'none');

            // Set phone length properties based on the selected country
            this.setPhoneNumberInputProperties(this.currentCountry);

            // Clear the mobile number and error messages when changing countries
            this.customErrorMessage = '';
            this.mobileNumber = '';

            // Reset validation
            this.$nextTick(() => {
                if (this.$refs.mobileNumberProvider) {
                    // Reset the specific mobile number provider if it exists
                    this.$refs.mobileNumberProvider.reset();
                } else {
                    // Fallback to resetting the entire form
                    this.$refs.observer.reset();
                }

                // For POA clients where mobile is required, update the placeholder message
                if (this.poaClient && this.showMobileField) {
                    const phoneInput = document.getElementById('phone-number');
                    if (phoneInput) {
                        phoneInput.placeholder = this.$t('pages.selfservice.registration.userDetails.mobilenumberrequired');
                    }
                }
            });
        },
        setDefaultCountry () {
            // Default to UK for PSC partners; otherwise fall back to US.
            const defaultCode = this.pscClient ? 'GB' : 'US';
            const defaultCountry = this.getDialCodeCountryList().find((country) => country.code === defaultCode);
            this.selectCountry(defaultCountry);
        },
        setPhoneNumberInputProperties (country) {
            const phoneLength = country.phoneLength;
            if (phoneLength) {
                let maxLength;
                if (Array.isArray(phoneLength)) {
                    maxLength = phoneLength[phoneLength.length - 1];
                } else if (typeof phoneLength === 'number') {
                    maxLength = phoneLength;
                }
                const phoneInput = document.getElementById('phone-number');
                if (phoneInput) {
                    phoneInput.setAttribute('maxlength', maxLength);
                    // Add placeholder text based on client type
                    if (this.poaClient) {
                        // Required field for POA client
                        phoneInput.placeholder = this.$t('pages.selfservice.registration.userDetails.mobilenumberrequired');
                    } else {
                        phoneInput.placeholder = this.$t('pages.selfservice.registration.userDetails.mobilenumberone');
                    }
                }

                this.dialPhoneLength = maxLength;
                // Reset validation after phone length changes
                this.$nextTick(() => {
                    if (this.mobileNumber && this.mobileNumber.trim() !== '') {
                        // Revalidate existing phone number with new length requirements
                        const errorMessage = this.isInvalidMobileNumber(this.mobileNumber);
                        this.customErrorMessage = errorMessage;
                    }
                });
            }
        },
        validatePhoneNumber (phoneNumber, countryCode) {
            if (!this.phoneNumberLib) {
                return { valid: true };
            }
            const { isValidPhoneNumber, isPossiblePhoneNumber } = this.phoneNumberLib;
            const isValid = isValidPhoneNumber(phoneNumber, countryCode.code);
            const isPossible = isPossiblePhoneNumber(phoneNumber, countryCode.code);
            if (!isValid || !isPossible) {
                const phoneLength = countryCode.phoneLength;
                let maxLength;
                if (phoneLength) {
                    if (Array.isArray(phoneLength)) {
                        maxLength = phoneLength[phoneLength.length - 1];
                    } else if (typeof phoneLength === 'number') {
                        maxLength = phoneLength;
                    }
                }
                return { valid: false, message: `${this.$t('pages.selfservice.registration.userDetails.mobilenumbererror')} ${maxLength}${this.$t('pages.selfservice.registration.userDetails.mobilenumbererrorone')}` };
            } else {
                return { valid: true };
            }
        },
        isInvalidMobileNumber (mobile) {
            if (!mobile || !mobile.trim()) {
                // Handle empty mobile number
                return this.poaClient
                    ? this.$t('pages.selfservice.registration.userDetails.mobilenumberfieldrequired')
                    : '';
            }

            // Ensure we're working with a clean string of digits
            const mobileNo = mobile.replace(/\D/g, '');

            const currentCountry = this.currentCountry || this.getDialCodeCountryList().find((country) => country.code === 'US');

            // Length validation
            const phoneLength = currentCountry.phoneLength;
            let validLengths = [];
            if (Array.isArray(phoneLength)) {
                validLengths = phoneLength;
            } else if (typeof phoneLength === 'number') {
                validLengths = [phoneLength];
            }

            if (validLengths.length > 0 && !validLengths.includes(mobileNo.length)) {
                const lengthStr = validLengths.length > 1
                    ? `${validLengths.join(' or ')}`
                    : `${validLengths[0]}`;
                return `${this.$t('pages.selfservice.registration.userDetails.mobilenumbererror')} ${lengthStr}${this.$t('pages.selfservice.registration.userDetails.mobilenumbererrorone')}`;
            }

            // Ensure it's all digits (should be redundant due to earlier cleaning, but keeping as a safeguard)
            if (!/^\d+$/.test(mobileNo)) {
                return this.$t('pages.selfservice.registration.userDetails.invalidFormat');
            }

            const fullPhoneNumber = `${currentCountry.dialCode}${mobileNo}`;

            if (this.phoneNumberLib) {
                const { isValidPhoneNumber, isPossiblePhoneNumber } = this.phoneNumberLib;
                const isPossible = isPossiblePhoneNumber(fullPhoneNumber, currentCountry.code);
                if (!isPossible) {
                    return this.$t('pages.selfservice.registration.userDetails.mobilenumberinvalidformat');
                }

                const isValid = isValidPhoneNumber(fullPhoneNumber, currentCountry.code);
                if (!isValid) {
                    return this.$t('pages.selfservice.registration.userDetails.mobilenumberinvalidforcountry');
                }
            }

            // Convert to array of digits for pattern validation
            const digits = mobileNo.split('').map(Number);
            // Check for repeating digits (e.g., 1111111111)
            if (_.uniq(digits).length === 1) {
                return this.$t('pages.selfservice.registration.userDetails.mobilenumberrepeatingdigits');
            }

            // Check for sequential patterns
            let isIncreasing = true;
            let isDecreasing = true;
            for (let i = 1; i < digits.length; i++) {
                if (digits[i] !== digits[i - 1] + 1) isIncreasing = false;
                if (digits[i] !== digits[i - 1] - 1) isDecreasing = false;
            }
            if (isIncreasing || isDecreasing) {
                return this.$t('pages.selfservice.registration.userDetails.mobilenumbersequentialdigits');
            }
            // If we reach here, the phone number is valid
            return '';
        },
        setClass (property) {
            if (property.title === 'First Name') {
                return 'ies-label-group-alt givenname';
            } else if (property.title === 'Last Name') {
                return 'ies-label-group-alt sn';
            } else if (property.title === 'Email Address') {
                if (this.pvsScholarship) {
                    return 'ies-label-group-alt mail';
                }
                return 'ies-label-group-alt';
            } else if (property.title === 'Username') {
                return 'ies-label-group-alt uid';
            }
        },
        backUrl (event) {
            const goToUrl = this.$route.query.goto;
            if (!goToUrl) {
                event.preventDefault();
                window.location.assign(window.location.origin + '/auth/XUI/?realm=/pearson&service=AuthN#login/');
            }
        }
    }
};
</script>

<style scoped lang="scss">
@import '../../../scss/pearson-common.css';
@import '../../../scss/theme-variables.scss';
// Accessibility: Always underline Terms/Privacy links in static text
.registration-terms-policy a,
.registration-terms-policy a:visited {
    text-decoration: underline;
}
</style>
